module.exports = __webpack_public_path__ + "img/kg.aed51cde.png";